import React from 'react';
import './Home.css';
import { useLanguage } from '../context/LanguageContext';
import Icon from '../components/Icon';

const Home = () => {
  const { t } = useLanguage();

  return (
    <div className="home-page">
      <section className="hero-section">
        <div className="container hero-wrapper">
          <div className="hero-image-side">
            <img
              src="/Assets/home/dev.jpg"
              alt={t('templeTitle')}
              className="hero-img-small"
            />
          </div>
          <div className="hero-text-side">
            <h1 className="hero-title-main">
              {t('pageContent.heroTitleSentence')}
            </h1>
            <div className="hero-timing-highlight">
              <div className="timing-box">
                <span className="timing-icon"><Icon name="clock" /></span>
                <div className="timing-info">
                  <span className="timing-label">{t('home.darshanTimings')}</span>
                  <div className="timing-hours">
                    <span className="morning">{t('home.morning')}</span>
                    <span className="separator">|</span>
                    <span className="evening">{t('home.evening')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="running-banner">
        <div className="banner-content">
          <div className="marquee">
            <span className="marquee-text">
              <span className="star">★</span> {t('pageContent.welcomeTitle')} : {t('home.marqueeMessage')} <span className="star">★</span>
            </span>
            <span className="marquee-text">
              <span className="star">★</span> {t('pageContent.welcomeTitle')} : {t('home.marqueeMessage')} <span className="star">★</span>
            </span>
          </div>
        </div>
      </section>

      <section className="temple-showcase" id="showcase">
        <div className="container">
          <h2 className="section-title">{t('home.showcase.title')}</h2>
          <div className="divider"></div>
          <div className="showcase-grid">
            <div className="showcase-image">
              <img
                src="Assets/home/temple-architecture.jpg"
                alt={t('home.showcase.overlayText')}
                className="temple-image"
              />
              <div className="image-overlay">
                <p className="overlay-text">{t('home.showcase.overlayText')}</p>
              </div>
            </div>
            <div className="showcase-info">
              <div className="info-card">
                <div className="info-icon"><Icon name="temple" /></div>
                <h3>{t('home.showcase.magnificenttitle')}</h3>
                <p>
                  {t('home.showcase.magnificentText')}
                </p>
              </div>
              <div className="info-card">
                <div className="info-icon"><Icon name="lamp" /></div>
                <h3>{t('home.showcase.dailyPoojaTitle')}</h3>
                <p>
                  {t('home.showcase.dailyPoojaText')}
                </p>
              </div>
              <div className="info-card">
                <div className="info-icon"><Icon name="prayer" /></div>
                <h3>{t('home.showcase.spiritualityTitle')}</h3>
                <p>
                  {t('home.showcase.spiritualityText')}
                </p>
              </div>
              <div className="info-card">
                <div className="info-icon"><Icon name="festival" /></div>
                <h3>{t('home.showcase.festivalTraditionTitle')}</h3>
                <p>
                  {t('home.showcase.festivalTraditionText')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>



      <section className="facts-section" id="facts">
        <div className="container">
          <h2 className="section-title">{t('home.facts.title')}</h2>
          <div className="divider"></div>
          <div className="facts-grid">
            <div className="fact-card visible">
              <div className="fact-icon"><Icon name="clock" /></div>
              <h3>{t('home.facts.darshanTitle')}</h3>
              <p>{t('home.facts.darshanText')}</p>
            </div>
            <div className="fact-card visible">
              <div className="fact-icon"><Icon name="location" /></div>
              <h3>{t('home.facts.locationTitle')}</h3>
              <p>{t('home.facts.locationText')}</p>
            </div>
            <div className="fact-card visible">
              <div className="fact-icon"><Icon name="car" /></div>
              <h3>{t('home.facts.reachTitle')}</h3>
              <p>{t('home.facts.reachText')}</p>
            </div>
            <div className="fact-card visible">
              <div className="fact-icon"><Icon name="phone" /></div>
              <h3>{t('home.facts.contactTitle')}</h3>
              <p>{t('home.facts.contactText')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="events-section" id="events">
        <div className="container">
          <h2 className="section-title">{t('home.festivals.title')}</h2>
          <div className="divider"></div>
          <div className="events-grid">
            <div className="event-card visible">
              <div className="event-date">{t('home.festivals.annualYatraDate')}</div>
              <h3>{t('home.festivals.annualYatraTitle')}</h3>
              <p>{t('home.festivals.annualYatraText')}</p>
            </div>
            <div className="event-card visible">
              <div className="event-date">{t('home.festivals.shravanMonth')}</div>
              <h3>{t('home.festivals.shravanTitle')}</h3>
              <p>{t('home.festivals.shravanText')}</p>
            </div>
            <div className="event-card visible">
              <div className="event-date">{t('home.festivals.everyMonth')}</div>
              <h3>{t('home.festivals.poornimaTitle')}</h3>
              <p>{t('home.festivals.poornimaText')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="rituals-section" id="rituals">
        <div className="container">
          <h2 className="section-title">{t('home.rituals.title')}</h2>
          <div className="divider"></div>
          <div className="rituals-grid">
            <div className="ritual-card visible">
              <div className="ritual-time">{t('home.rituals.kakadAartiTime')}</div>
              <h3>{t('home.rituals.kakadAartiTitle')}</h3>
              <p>{t('home.rituals.kakadAartiHours')}</p>
              <ul>
                {t('home.rituals.kakadAartiList', { returnObjects: true }).map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="ritual-card visible">
              <div className="ritual-time">{t('home.rituals.abhishekPoojaTime')}</div>
              <h3>{t('home.rituals.abhishekPoojaTitle')}</h3>
              <p>{t('home.rituals.abhishekPoojaHours')}</p>
              <ul>
                {t('home.rituals.abhishekPoojaList', { returnObjects: true }).map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="ritual-card visible">
              <div className="ritual-time">{t('home.rituals.dhupAartiTime')}</div>
              <h3>{t('home.rituals.dhupAartiTitle')}</h3>
              <p>{t('home.rituals.dhupAartiHours')}</p>
              <ul>
                {t('home.rituals.dhupAartiList', { returnObjects: true }).map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="ritual-card visible">
              <div className="ritual-time">{t('home.rituals.specialPoojaTime')}</div>
              <h3>{t('home.rituals.specialPoojaTitle')}</h3>
              <p>{t('home.rituals.specialPoojaNote')}</p>
              <ul>
                {t('home.rituals.specialPoojaList', { returnObjects: true }).map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="facilities-section" id="facilities">
        <div className="container">
          <h2 className="section-title">{t('home.facilities.title')}</h2>
          <div className="divider"></div>
          <div className="facilities-grid">
            <div className="facility-card visible">
              <div className="facility-icon"><Icon name="car" /></div>
              <h3>{t('home.facilities.parkingTitle')}</h3>
              <p>{t('home.facilities.parkingText')}</p>
            </div>
            <div className="facility-card visible">
              <div className="facility-icon"><Icon name="restroom" /></div>
              <h3>{t('home.facilities.restroomTitle')}</h3>
              <p>{t('home.facilities.restroomText')}</p>
            </div>
            <div className="facility-card visible">
              <div className="facility-icon"><Icon name="water" /></div>
              <h3>{t('home.facilities.waterTitle')}</h3>
              <p>{t('home.facilities.waterText')}</p>
            </div>
            <div className="facility-card visible">
              <div className="facility-icon"><Icon name="food" /></div>
              <h3>{t('home.facilities.prasadTitle')}</h3>
              <p>{t('home.facilities.prasadText')}</p>
            </div>
            <div className="facility-card visible">
              <div className="facility-icon"><Icon name="accessibility" /></div>
              <h3>{t('home.facilities.seniorTitle')}</h3>
              <p>{t('home.facilities.seniorText')}</p>
            </div>
            <div className="facility-card visible">
              <div className="facility-icon"><Icon name="bag" /></div>
              <h3>{t('home.facilities.materialTitle')}</h3>
              <p>{t('home.facilities.materialText')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="reach-section" id="reach">
        <div className="container">
          <h2 className="section-title">{t('home.reach.title')}</h2>
          <div className="divider"></div>
          <div className="reach-content">
            <div className="reach-card">
              <div className="reach-icon"><Icon name="train" /></div>
              <h3>{t('home.reach.railwayTitle')}</h3>
              <p>
                {t('home.reach.railwayText')}
              </p>
              <p>
                <strong>{t('home.reach.railwayNote')}</strong>
              </p>
            </div>
            <div className="reach-card">
              <div className="reach-icon"><Icon name="bus" /></div>
              <h3>{t('home.reach.busTitle')}</h3>
              <p>
                {t('home.reach.busText')}
              </p>
              <p>
                <strong>{t('home.reach.busNote')}</strong>
              </p>
            </div>
            <div className="reach-card">
              <div className="reach-icon"><Icon name="car" /></div>
              <h3>{t('home.reach.carTitle')}</h3>
              <p>
                {t('home.reach.carText')}
              </p>
              <p>
                <strong>{t('home.reach.carNote')}</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;


